export default __webpack_public_path__ + "static/media/north-coverpic.fd2f7f69.svg";